export type DashboardTab = 'courses' | 'projects' | 'academy' | 'interviews' | 'events';

export const DASHBOARD_TABS: DashboardTab[] = ['courses', 'projects', 'academy', 'interviews', 'events'];

export const isDashboardTab = (value: string | null): value is DashboardTab =>
  !!value && DASHBOARD_TABS.includes(value as DashboardTab);

/** Header order: Courses → Projects → IDC Academy → Interviews, then Events. */
export const dashboardTabFromPath = (pathname: string): DashboardTab => {
  if (pathname.startsWith('/programs')) return 'academy';
  if (pathname.startsWith('/projects')) return 'projects';
  if (pathname.startsWith('/events')) return 'events';
  if (pathname.startsWith('/interviews')) return 'interviews';
  if (pathname.startsWith('/courses')) return 'courses';
  return 'courses';
};

export const dashboardPath = (tab: DashboardTab = 'courses') =>
  tab === 'courses' ? '/dashboard' : `/dashboard?tab=${tab}`;
